import { useState } from 'react';
import { selectCurrentUser } from '../../redux/user/user.selector';
import axios from 'axios';
import Container from '@mui/material/Container';
import EmailInput from '../../components/email-input/email-input.component';
import { useSelector } from 'react-redux';

export default function UsernameResetPage({
  setModalOpen,
  setModalText,
  setModalLoading,
}) {
  const currUser = useSelector(selectCurrentUser);
  let [oldEmail, setOldEmail] = useState('');
  let [newEmail, setNewEmail] = useState('');

  let [loadingNavitaire, setLoadingNavitaire] = useState(false);

  async function resetUsername() {
    setLoadingNavitaire(true);

    let res;
    try {
      if (!oldEmail || !newEmail) {
        alert('Please fill out all fields');
        setLoadingNavitaire(false);
        return;
      }
      res = await axios({
        method: 'post',
        url:
          process.env.REACT_APP_LOCAL_URL + '/automation/resetCustomerUsername',
        data: {
          oldEmail: oldEmail,
          newEmail: newEmail,
          userAuth: currUser,
        },
      });

      setModalText(res.data.message);
      setModalLoading(false);
      setModalOpen(true);
      setLoadingNavitaire(false);
    } catch (error) {
      console.log(error.response);
      setModalText(error.response.data.message);
      setLoadingNavitaire(false);
      setModalLoading(false);
      setModalOpen(true);

      return error;
    }
  }

  return (
    <>
      <Container
        maxWidth="lg"
        sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
      >
        <EmailInput
          email={oldEmail}
          setEmail={setOldEmail}
          loading={loadingNavitaire}
          button={false}
          label="Old Email"
        />
        <EmailInput
          email={newEmail}
          setEmail={setNewEmail}
          loading={loadingNavitaire}
          handleClick={resetUsername}
          button={true}
          label="New Email"
          buttonText={'Reset Username'}
        />
      </Container>
    </>
  );
}
